// extracted by mini-css-extract-plugin
export default {"containerBtn":"styles-scoped__containerBtn--l8AUx","btn":"styles-scoped__btn--K7lpJ","formContainer":"styles-scoped__formContainer--G0nyM","icon":"styles-scoped__icon--WN0Mh"};